import {
	ChangeDetectorRef,
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewChild,
} from "@angular/core";
import { AuthenticationService } from "core/authentication.service";
import { DisclaimerResource, NotificationResource } from "core/stages-client";
import { MutexService } from "common/concurrency/mutex.service";
import { NewDialogComponent } from "common/newdialog/dialog.component";

@Component({
	selector: "stages-disclaimer",
	templateUrl: "./disclaimer-login.component.html",
	styleUrls: ["./disclaimer-login.component.scss"],
})
export class DisclaimerLoginComponent implements OnInit {
	acceptButtonVisible: boolean = false;
	fileError: boolean = false;
	textContent: string = "";
	isScrollable: boolean = false;

	@ViewChild("dialog", { static: false })
	dialog?: NewDialogComponent;

	@ViewChild("disclaimerTextElement", { static: false })
	disclaimerTextElement?: ElementRef;

	@Input()
	disclaimerVersion: string | null = null;

	@Output()
	readonly markedDisclaimerAsAccepted = new EventEmitter<boolean>();

	constructor(
		private authService: AuthenticationService,
		private notificationResource: NotificationResource,
		private mutexService: MutexService,
		private disclaimerResource: DisclaimerResource,
		private changeDetector: ChangeDetectorRef,
	) {}

	async ngOnInit(): Promise<void> {
		if (this.disclaimerVersion !== null) {
			try {
				this.textContent = await this.disclaimerResource.getDisclaimerVersionText();
				this.changeDetector?.detectChanges();
				const text = this.disclaimerTextElement?.nativeElement;
				this.isScrollable = text.scrollHeight > text.clientHeight;
				this.acceptButtonVisible = !this.isScrollable;
			} catch {
				this.fileError = true;
			}
		}
	}

	enableAcceptButton(): void {
		const scrollableText = this.disclaimerTextElement?.nativeElement;
		if (scrollableText && this.isScrollable) {
			const scrollTop: number = scrollableText.scrollTop;
			const scrollOffset: number = scrollableText.offsetHeight;
			const scrollPos = scrollTop + scrollOffset;
			if (scrollPos >= scrollableText.scrollHeight) {
				this.acceptButtonVisible = true;
			}
		}
	}

	async logOutUser(): Promise<void> {
		await this.authService.logout(null);
	}

	acceptTerms(): void {
		const disclaimer = "Disclaimer";
		this.mutexService.invoke("markAsSeen" + disclaimer, async () =>
			this.notificationResource.markAsSeen({ objectType: "disclaimer", objectId: this.disclaimerVersion }),
		);
	}
}
